//========================================================================================
/*

  label       [string]
  isRequired  [bool]
  selected    [moment]
  dateFormat  [str]
  readOnly    [bool]
  minDate     [moment]
  onChange    [func]
  showArrow   [bool]
    
 */
//========================================================================================


import styled from 'styled-components';
import ReactDatePicker from 'react-datepicker';
import { InputLabel, Required } from 'styles/common';

const DataPikerWrapper = styled.div`
  .react-datepicker-wrapper {
    display: block;
  }
  .react-datepicker__input-container {
    display: block;
    position: relative;
    &:after {
      display: ${p => p.showArrow ? 'block' : 'none'};
      content: '';
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid ${p => p.theme.color.label};
      position: absolute;
      right: .8em;
      top: 49%;
    }    
  }
  .react-datepicker__close-icon:after {
    background-color: ${p => p.theme.color.primary};
    top: 54%;
  }
  input {
    margin-top: 4px;
    width: 100%;
    box-sizing: border-box;
    outline: none;
    font-size: 1em;
    padding: 0.625em;
    border: solid 1px ${p => p.theme.color.border};
    border-radius: 4px;
    width: 100%;
    box-sizing: border-box;
    color: ${p => p.theme.color.text};
    &:disabled {
      background-color: ${p => p.theme.color.background};
      color: ${p => p.theme.color.label};
    }
  }
`;

export default props => (
  <DataPikerWrapper showArrow={props.showArrow}>
    <InputLabel className="input-label">
      {props.label}
      {props.isRequired && <Required> *</Required>}
    </InputLabel>
    <ReactDatePicker {...props} />
  </DataPikerWrapper>
);
